export const useSpecialActionComponents = () => {
  const mountedComponents = useState<Set<string>>('special-action-components', () => new Set());

  const isComponentMounted = (componentType: string) => {
    return mountedComponents.value.has(componentType);
  };

  const mountComponent = (componentType: string) => {
    mountedComponents.value.add(componentType);
  };

  const getUniqueComponents = (specialActions: string[]) => {
    const uniqueComponents: string[] = [];
    
    specialActions.forEach(action => {
      if (!isComponentMounted(action)) {
        mountComponent(action);
        uniqueComponents.push(action);
      }
    });

    return uniqueComponents;
  };

  return {
    isComponentMounted,
    mountComponent,
    getUniqueComponents,
  };
}; 